import React, { useState, useEffect, useMemo, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import initData from '../Home/initData';
import { TablesFetchAPI } from '../../api/Tables';
import { ProductContext } from '../../context/ProductContext';
import ErrorAlert from '../Alerts/ErrorAlert';

import Btnquote from '../../utils/Btnquote';
import './menu.css';
import { ModalProduct } from './ModalProduct';
import moment from 'moment';
import Footer from '../Home/Footer';
import HeaderMain from '../Home/Headers/HeaderMain';
import useSEO from '../../hooks/useSEO';
import ProductsPage from '../Product/ProductPage';
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";
import {
   getCartAvailabilityMessage,
   sanitizeStoredCartAgainstMenu
} from '../../utils/cartAvailability';
import AlertSmall from '../Alerts/AlertSmall';
import { isActiveTableSessionStatus, useTableSession } from '../../context/TableSessionContext';
export const Menu = () => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   const { session: tableSession, status: tableSessionStatus } = useTableSession();

   const [business_code] = useState(() => {
      if (localStorage.getItem("business") !== "" && localStorage.getItem("business") !== undefined) {
         return JSON.parse(localStorage.getItem("business")).code;
      }
   });

   // Context
   const { setProductData } = useContext(ProductContext);

   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);
   const menuType = queryParams.get('type');

   // STATES MENU
   const [categories, setCategories] = useState([]);
   const [favorites, setFavorites] = useState([]);
   const [groups, setGroups] = useState([]);
   const [categorieNow, setCategorieNow] = useState({});
   const [handlerEvent, setHandlerEvent] = useState(0);
   const [selectedGroup, setSelectedGroup] = useState({});
   const [segmentsGroup, setSegmentsGroup] = useState([]);
   const [shoppingcart, setShoppingcart] = useState([]);
   const [shoppingCartCombos, setShoppingCartCombos] = useState([]);
   const [moduleCategories, setModuleCategories] = useState(true);
   const [theme, setSetTheme] = useState("light");
   const [seoContent, setSeoContent] = useState(null);
   const [quoteMode, setQuoteMode] = useState(false);
  const filtersBarRef = useRef(null);
   // Filter states
   const [searchTerm, setSearchTerm] = useState('');
   const [temporalProducts, setTemporalProducts] = useState([]);

   // ✅ Loading para skeleton
   const [loading, setLoading] = useState(true);

   // Auth params localstorage
   let machine = "";
   let business = "";
   let branchoffice = "";
   let logo = "";
   let params = false;
   let token = undefined;

   if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
      logo = localStorage.getItem('logo');
   }

   if (
      localStorage.getItem("branchoffice") == "" ||
      localStorage.getItem("branchoffice") == undefined ||
      localStorage.getItem("machine") == "" ||
      localStorage.getItem("machine") == undefined
   ) {
      // sin params
   } else {
      params = true;
      branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
      machine = JSON.parse(localStorage.getItem('machine'));
      business = JSON.parse(localStorage.getItem("business"));
   }

   // SEO Inicial
   useSEO({
      title: "Menú",
      bussines_name: business?.name,
      description: "Explore nuestro menú y disfrute de una experiencia única.",
      icon: seoContent?.icon?.url || logo
   });

   const [view, setView] = useState("grid");
   const hasActiveTableSession = isActiveTableSessionStatus(tableSessionStatus);
   // Para los handlers async de abajo (que corren despues de pedir datos y no deben leer un valor viejo).
   const hasActiveTableSessionRef = useRef(false);
   hasActiveTableSessionRef.current = hasActiveTableSession;
   const tableSessionLabel = tableSession?.table?.name || tableSession?.table?.number || "";
   const tableEnvironmentLabel = tableSession?.table?.environment || "";

   // ✅ Filter the products by the term searched (con guards)
   const filteredProducts = useMemo(() => {
      const q = (searchTerm || "").trim().toLowerCase();
      if (!q) return groups;

      return (groups || []).filter(product => {
         const name = (product?.name || "").toLowerCase();
         const description = (product?.description || "").toLowerCase();
         const price = (product?.price ?? "").toString().toLowerCase();

         return (
            name.includes(q) ||
            description.includes(q) ||
            price.includes(q)
         );
      });
   }, [searchTerm, groups]);

   // ✅ Empty state config (busqueda / categoria sin productos)
   const emptyState = useMemo(() => {
      const hasSearch = (searchTerm || "").trim().length > 0;
      const isEmpty = !loading && (filteredProducts?.length || 0) === 0;

      if (!isEmpty) return null;

      // Caso 1: búsqueda sin coincidencias
      if (hasSearch) {
         const term = searchTerm.trim();
         return {
            icon: "🔎",
            title: t('menu.noMatches'),
            description: t('menu.noMatchesDescription', { term }),
            action: (
               <button type="button" className="prts-empty-btn" onClick={() => setSearchTerm("")}>
                  {t('menu.clearSearch')}
               </button>
            ),
         };
      }

      // Caso 2: categoría sin productos
      const label =
         categorieNow === "all"
            ? t('menu.allCategories')
            : categorieNow === "favorites"
               ? t('menu.favorites')
               : (categorieNow?.category_name || t('menu.thisCategory'));

      return {
         icon: "📦",
         title: t('menu.noProductsAvailable'),
         description: t('menu.noProductsDescription', { label }),
         action: (
            <button type="button" className="prts-empty-btn" onClick={() => selectCategorie("all")}>
               {t('menu.seeAll')}
            </button>
         ),
      };
   }, [loading, filteredProducts, searchTerm, categorieNow, t]);

   //function get day
   const getDayNow = () => {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const daysInEnglish = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      return daysInEnglish[dayOfWeek];
   };

   //function get interval time betwen catalog
   const filterByTimeRange = (array) => {
      const currentTime = moment();
      return array.filter(({ minHour, maxHour }) => {
         const minTime = moment(minHour, 'HH:mm:ss');
         const maxTime = moment(maxHour, 'HH:mm:ss');
         if (maxTime.isBefore(minTime)) {
            return currentTime.isAfter(minTime) || currentTime.isBefore(maxTime);
         }
         return currentTime.isBetween(minTime, maxTime, null, '[)');
      });
   };

   //consolidates data into corresponding statements
   const dataconsolidation = (generalData) => {
      if (generalData == 'error') {
         // Con una sesion de mesa activa la sucursal la fija la mesa: ir a /branch no sirve (BranchSelectNew
         // detecta la sesion y regresa a /menu), solo provoca un bucle. Se avisa y se deja el menu como esta.
         if (hasActiveTableSessionRef.current) {
            ErrorAlert('', t('menu.loadError', { defaultValue: 'No se pudo cargar el menu. Revisa tu conexion e intenta de nuevo.' }), 'warning', 8000);
            return;
         }
         ErrorAlert('', t('menu.mustSelectRestaurant'), 'info', 8000);
         navigate(`/branch`);
         return;
      }

      let data = generalData;
      const cartAvailability = sanitizeStoredCartAgainstMenu(data);

      if (cartAvailability.changed) {
         AlertSmall(getCartAvailabilityMessage(cartAvailability), "info");
      }

      // all groups
      let dataGroups = data.groups;
      let groups_all = dataGroups.filter(({ status }) => status === 1);
      setTemporalProducts(groups_all);

      // categories
      let categories_info = data.category;
      let catalogsavailable = data.catalogs.filter(({ status }) => status === 1);
      let dataday = getDayNow();
      let filterCatalogsDay = catalogsavailable.filter((catalog) => catalog[dataday] === 1);
      let catalogInTime = filterByTimeRange(filterCatalogsDay);

      if (catalogInTime.length > 0) {
         let catalogToCategories = [];
         categories_info.forEach((category) => {
            let filter = catalogInTime[0].categories.find(({ category_id }) => category_id == category.category_id);
            if (filter != undefined) catalogToCategories.push(category);
         });
         setCategoriesShow(catalogToCategories);
      } else {
         setCategoriesShow(categories_info);
      }

      function setCategoriesShow(categoriesDetails) {
         let dataCategories = categoriesDetails;
         let typeCodeCategories = 'P';
         let categoriesFilter = dataCategories.filter(({ code, available_ecommerce }) => code === typeCodeCategories && available_ecommerce == 1);
         setCategories(categoriesFilter);

         // safe all groups by categories
         let allgroupsByCategories = [];
         categoriesFilter.forEach((categorie) => {
            allgroupsByCategories = allgroupsByCategories.concat(categorie.groups);
         });

         allgroupsByCategories = allgroupsByCategories.filter(({ available_ecommerce }) => available_ecommerce == 1);

         if (menuType == "points") {
            allgroupsByCategories = allgroupsByCategories.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1);
         }

         setGroups(allgroupsByCategories);

         // favorites
         let dataFavoriteGroups = allgroupsByCategories.filter(({ favorite }) => favorite == 1);
         if (menuType == "points") {
            dataFavoriteGroups = dataFavoriteGroups.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1);
         }
         setFavorites(dataFavoriteGroups);

         // selected categorie
         if (hasActiveTableSession) {
            // Sesion de mesa (QR pre-pago/post-pago): ignorar la categoria persistida en
            // localStorage - queda de CUALQUIER sesion anterior en este navegador (otra mesa, hasta
            // otro negocio), asi que puede apuntar a una categoria que en el catalogo de ESTA
            // sucursal/horario no tiene productos (o ya no existe), mostrando "no hay productos" apenas
            // se entra a la mesa. "Ver todos" siempre tiene contenido (es groups_all sin filtrar por
            // categoria), asi que es el unico default seguro al iniciar una sesion de mesa.
            localStorage.setItem('selectedCategorie', JSON.stringify('all'));
            setCategorieNow('all');
            setGroups(groups_all.filter(({ available_ecommerce }) => available_ecommerce == 1));
         } else {
            let selectCategorieLS = localStorage.getItem('selectedCategorie');
            if (selectCategorieLS != null && selectCategorieLS != undefined && selectCategorieLS != '') {
               let categorie = JSON.parse(selectCategorieLS);
               let filterCategorieSelect = categoriesFilter.filter(({ category_id }) => category_id == categorie.category_id);

               if (filterCategorieSelect.length > 0) {
                  setCategorieNow(categorie);

                  let products = BildGroupsAndGroups(categorie);
                  products = products.filter(({ available_ecommerce }) => available_ecommerce == 1);

                  if (menuType == "points") {
                     products = products.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1);
                  }
                  setGroups(products);
               } else {
                  setDefaultCategorie();
               }
            } else {
               setDefaultCategorie();
            }
         }

         function setDefaultCategorie() {
            if (dataCategories.length > 0) {
               localStorage.setItem('selectedCategorie', JSON.stringify(dataCategories[0]));
               setCategorieNow(dataCategories[0]);

               let products = BildGroupsAndGroups(dataCategories[0]);
               products = products.filter(({ available_ecommerce }) => available_ecommerce == 1);
               setGroups(products);
               setHandlerEvent(1);
            } else {
               if (menuType == "points") navigate(`/home/?type=points`);
               else navigate(`/home`);
            }
         }

         function BildGroupsAndGroups(categorie) {
            let allProducts = categorie.groups;
            let arrayCombos = categorie.combos;

            arrayCombos.forEach((dataCombos) => {
               let priceCombo = 0;
               if (dataCombos.setGroups.length > 0) {
                  dataCombos.setGroups.forEach((combo) => {
                     if (combo.groups.length > 0) {
                        priceCombo = (combo.groups[0].price + priceCombo);
                     }
                  });
                  dataCombos.price = priceCombo;
               }
            });

            return allProducts.concat(categorie.combos);
         }
      }

      // shopping carts
      if (!localStorage.getItem('shoppingCart')) setShoppingcart([]);
      else setShoppingcart(JSON.parse(localStorage.getItem('shoppingCart')));

      if (!localStorage.getItem('shoppingCartCombos')) setShoppingCartCombos([]);
      else setShoppingCartCombos(JSON.parse(localStorage.getItem('shoppingCartCombos')));

      // Ecommerce config
      let dataEcommerceContentUi = data.ecommerce_content.ui_config;
      setQuoteMode(dataEcommerceContentUi?.quotes?.enabled == true ? true : false);
      localStorage.setItem("quoteMode", dataEcommerceContentUi?.quotes?.enabled == true ? "true" : "false");

      setModuleCategories(dataEcommerceContentUi.categories.enabled);

      let themeInit = dataEcommerceContentUi.theme;
      setSetTheme(themeInit);
      if (!localStorage.getItem("theme")) {
         localStorage.setItem("theme", themeInit);
      }
   };

   //========================================================================================
   const selectCategorie = (categorie) => {
      // "all" / "favorites" también deben guardarse, pero si quieres evitar JSON.stringify("all") puedes hacerlo condicional
      localStorage.setItem('selectedCategorie', JSON.stringify(categorie));
      setCategorieNow(categorie);

      let products = [];
      if (categorie == "favorites") {
         products = favorites;
      } else if (categorie == "all") {
         products = temporalProducts;
      } else {
         let allProducts = categorie.groups;
         let arrayCombos = categorie.combos;

         arrayCombos.forEach((dataCombos) => {
            let priceCombo = 0;
            if (dataCombos.setGroups.length > 0) {
               dataCombos.setGroups.forEach((combo) => {
                  if (combo.groups.length > 0) {
                     priceCombo = (combo.groups[0].price + priceCombo);
                  }
               });
               dataCombos.price = priceCombo;
            }
         });

         if (menuType == "points") {
            allProducts = allProducts.filter(({ can_be_paid_with_points }) => can_be_paid_with_points == 1);
         }

         products = allProducts.concat(categorie.combos);
      }

      products = products.filter(({ available_ecommerce }) => available_ecommerce == 1);
      setGroups(products);
      setHandlerEvent(1);
   };

   //=========================================================================================
   const selectProduct = (data) => {
      setProductData(data);
      setSelectedGroup(data);

      if (data.segments) setSegmentsGroup(data.segments);
      else setSegmentsGroup([]);

      navigate("/product");
   };

   //============================================================================================
   const handlerInit = async () => {
      setLoading(true);
      try {
         let response = await initData();
         dataconsolidation(response);
      } catch (err) {
         console.log(err);
         // Ver dataconsolidation: con sesion de mesa activa /branch regresa a /menu (bucle).
         if (hasActiveTableSessionRef.current) {
            ErrorAlert('', t('menu.loadError', { defaultValue: 'No se pudo cargar el menu. Revisa tu conexion e intenta de nuevo.' }), 'warning', 8000);
         } else {
            navigate(`/branch`);
         }
      } finally {
         setLoading(false);
      }
   };

   //================================================================================================
   const getTableById = async () => {
      let token = undefined;
      let dataTable = JSON.parse(localStorage.getItem('table'));
      try {
         const response = await TablesFetchAPI.getTableById(dataTable.id, token);
         let tableNow = response.data.table;

         let codeRoom = localStorage.getItem('codeRoom');
         if (codeRoom != undefined || codeRoom != '' || codeRoom != null) {
            if (codeRoom != tableNow.password) {
               navigate(`/branch/${business_code}/${dataTable.table_code}`);
            }
         } else {
            navigate(`/branch/${business_code}/${dataTable.table_code}`);
         }
      } catch (err) {
         navigate(`/branch/${business_code}/${dataTable.table_code}`);
         console.log(err);
      }
   };

   useEffect(() => {
      handlerInit();
   }, []);

   useEffect(() => {
      setHandlerEvent(0);
   }, [handlerEvent]);


   const data =
   {
      business: {
         name: "SmartPay POS", address: "Ciudad de Panamá", ruc:
            "155664-1-123456 DV 99", phone: "6000-0000"
      }, customer: { name: "Cliente Final", doc: "CF" },
      invoiceNumber: "FAC-000124", date: "20/02/2026", paymentMethod: "Tarjeta", cashier: "Paulo",
      items: [{ name: "Perfume Dior Sauvage 100ml", qty: 1, price: 95 }, {
         name: "Recarga 60ml",
         qty: 2, price: 25
      }]
   };



   return (
      <>
         <div className="ecommerce-wrapper">
            <HeaderMain />


            <main className='prts-products-page'>
               {/* {hasActiveTableSession ? (
                  <div className="container pt-3">
                     <div className="alert alert-success py-2 mb-3">
                        {t('menu.tableActive', { table: tableSessionLabel || t('menu.tableActiveDefault') })}
                        {tableEnvironmentLabel ? ` · ${tableEnvironmentLabel}` : ""}
                     </div>
                  </div>
               ) : null} */}

               <header className="prts-products-header">
                  <h1>{t('nav.products')}</h1>

                  <div className="prts-search-wrap">
                     <SearchIcon />
                     <input
                        onChange={e => setSearchTerm(e.target.value)}
                        placeholder={t('menu.searchPlaceholder')}
                        aria-label={t('menu.searchAria')}
                        value={searchTerm}
                        data-prts-products-search
                     />
                  </div>

                  <div className="prts-view-toggle" role="tablist" aria-label={t('menu.viewAria')}>
                     <button
                        type="button"
                        className={`prts-view-btn ${view === "grid" ? "active" : ""}`}
                        onClick={() => setView("grid")}
                        aria-pressed={view === "grid"}
                        aria-label={t('menu.gridViewAria')}
                     >
                        <GridIcon />
                     </button>

                     {/* <button
                        type="button"
                        className={`prts-view-btn ${view === "list" ? "active" : ""}`}
                        onClick={() => setView("list")}
                        aria-pressed={view === "list"}
                        aria-label="Vista en lista"
                     >
                        <ListIcon />
                     </button> */}
                  </div>
               </header>

               {moduleCategories === true ? (
                  <FiltersBar
                     moduleCategories={moduleCategories}
                     categories={categories}
                     favorites={favorites}
                     categorieNow={categorieNow}
                     selectCategorie={selectCategorie}
                  />
               ) : null}

               {/* ✅ LISTADO con Skeleton / Empty / Cards */}
               {loading ? (
                  <ProductsSkeleton count={8} view={view} />
               ) : emptyState ? (
                  <EmptyState
                     icon={emptyState.icon}
                     title={emptyState.title}
                     description={emptyState.description}
                     action={emptyState.action}
                  />
               ) : (
                  <div className={`prts-product-grid ${view === "list" ? "list-view" : ""}`}>
                     {filteredProducts.map((product) => (
                        <article
                           key={product?.id || product?.group_id || product?.upc || product?.name}
                           className="prts-product-card"
                           onClick={() => selectProduct(product)}
                           role="button"
                           tabIndex={0}
                           onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                 e.preventDefault();
                                 selectProduct(product);
                              }
                           }}
                           aria-label={t('menu.openProductAria', { name: product?.name || t('menu.productFallback') })}
                        >
                           <div className="prts-card-img-wrap">
                              {product.badge ? <div className="prts-card-badge">{product.badge}</div> : null}

                              {/* <img src={product.img} alt={product.name} loading="lazy" /> */}
                              <img alt={product.name} loading="lazy"
                                 src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" })}
                                 onError={e => e.target.style.opacity = 0}
                              />
                              <button
                                 type="button"
                                 className="prts-card-overlay-btn"
                                 onClick={(e) => {
                                    e.stopPropagation();
                                    selectProduct(product);
                                 }}
                              >
                                 {t('menu.add')}
                              </button>
                           </div>

                           <div className="prts-card-body">
                              <div className="prts-card-info">
                                 <div className="prts-card-name">{product.name}</div>
                                 <div className="prts-card-desc">{product.description}</div>
                              </div>

                              <div className="prts-card-footer">
                                 <div>
                                    <div className="prts-card-price">{formatPrice(product.price)}</div>
                                 </div>

                                 <button
                                    type="button"
                                    className="prts-card-add-btn"
                                    onClick={(e) => {
                                       e.stopPropagation();
                                       selectProduct(product);
                                    }}
                                    aria-label={t('menu.addProductAria', { name: product.name })}
                                    title={t('menu.add')}
                                 >
                                    <PlusIcon />
                                 </button>
                              </div>
                           </div>
                        </article>
                     ))}
                  </div>
               )}

               <Footer />

            </main>
         </div>

         {quoteMode == true && <Btnquote />}

         <ModalProduct
            modalShow={false}
            setModalShow={() => { }}
            selectedGroup={selectedGroup}
            segmentsGroup={segmentsGroup}
            shoppingcart={shoppingcart}
            shoppingCartCombos={shoppingCartCombos}
            setShoppingCartCombos={setShoppingCartCombos}
            logo={logo}
            branchoffice={branchoffice}
            token={token}
         />
      </>
   );
};

/* ─────────────────────────────────────────
   Helpers
───────────────────────────────────────── */
function formatPrice(v) {
   if (v === null || v === undefined || v === "") return "";
   if (typeof v === "number") return `$${v.toFixed(2)}`;
   return String(v);
}

function FiltersBar({
   moduleCategories = true,
   categories = [],
   favorites = [],
   categorieNow,
   selectCategorie,
}) {
   const { t } = useTranslation();
   // ✅ useRef ANTES de cualquier return
   const filtersBarRef = useRef(null);

   const chips = useMemo(() => {
      const base = [{ key: "all", label: t('menu.seeAll') }];
      if ((favorites?.length || 0) > 0) base.push({ key: "favorites", label: t('menu.favorites') });
      (categories || []).forEach((c) => {
         base.push({ key: String(c.category_id), label: c.category_name, raw: c });
      });
      return base;
   }, [categories, favorites, t]);

   // ✅ Early return DESPUÉS de todos los hooks
   if (!moduleCategories) return null;

   const getActiveKey = () => {
      if (categorieNow === "all" || categorieNow === "favorites") return categorieNow;
      if (categorieNow?.category_id != null) return String(categorieNow.category_id);
      return "all";
   };

   const activeKey = getActiveKey();

   const handleClick = (chip) => {
      if (chip.key === "all") return selectCategorie("all");
      if (chip.key === "favorites") return selectCategorie("favorites");
      if (chip.raw) return selectCategorie(chip.raw);
   };

   const scrollChips = (dir) => {
      const el = filtersBarRef.current;
      if (!el) return;
      el.scrollBy({ left: dir * 160, behavior: "smooth" });
   };

   return (
      <div className="prts-filters-wrapper">


         <div className="prts-filters-bar" ref={filtersBarRef} role="toolbar" aria-label={t('menu.filtersAria')}>
            {chips.map((chip) => {
               const isActive = String(activeKey) === String(chip.key);
               return (
                  <button
                     key={chip.key}
                     type="button"
                     className={`prts-filter-chip ${isActive ? "active" : ""}`}
                     onClick={() => handleClick(chip)}
                     aria-pressed={isActive}
                  >
                     {chip.label}
                  </button>
               );
            })}
         </div>
         <button
            type="button"
            className="prts-filters-nav prts-filters-nav--prev"
            onClick={() => scrollChips(-1)}
            aria-label={t('menu.scrollLeftAria')}
         >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
               <path d="M10 3L5 8L10 13" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
         </button>
         <button
            type="button"
            className="prts-filters-nav prts-filters-nav--next"
            onClick={() => scrollChips(1)}
            aria-label={t('menu.scrollRightAria')}
         >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
               <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
         </button>
      </div>
   );
}

/* ✅ Skeleton Grid */
function ProductsSkeleton({ count = 8, view = "grid" }) {
   return (
      <div className={`prts-product-grid ${view === "list" ? "list-view" : ""}`}>
         {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="prts-product-card prts-skel-card" aria-hidden="true">
               <div className="prts-card-img-wrap prts-skel prts-skel-media" />
               <div className="prts-card-body">
                  <div className="prts-skel prts-skel-line" />
                  <div className="prts-skel prts-skel-line prts-w-70" />
                  <div className="prts-skel prts-skel-line prts-w-45" />
               </div>
            </div>
         ))}
      </div>
   );
}

/* ✅ Empty State */
function EmptyState({ icon = "ℹ️", title, description, action }) {
   return (
      <div className="prts-empty" role="status" aria-live="polite">
         <div className="prts-empty-icon">{icon}</div>
         <h3 className="prts-empty-title">{title}</h3>
         {description ? <p className="prts-empty-desc">{description}</p> : null}
         {action ? <div className="prts-empty-actions">{action}</div> : null}
      </div>
   );
}

function SearchIcon() {
   return (
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
         <path
            d="M10.5 18a7.5 7.5 0 1 1 5.2-12.9A7.5 7.5 0 0 1 10.5 18Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
         />
         <path
            d="M16.2 16.2 21 21"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
         />
      </svg>
   );
}

function GridIcon() {
   return (
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
         <path d="M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z" fill="currentColor" />
      </svg>
   );
}

function ListIcon() {
   return (
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
         <path d="M5 6h14v2H5V6Zm0 5h14v2H5v-2Zm0 5h14v2H5v-2Z" fill="currentColor" />
      </svg>
   );
}

function PlusIcon() {
   return (
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
         <path
            d="M12 5v14M5 12h14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
         />
      </svg>
   );
}
